export const SESSION_TOKEN_STORAGE_KEY = "auth_token";
export const ADMIN_SESSION_TOKEN_STORAGE_KEY = "admin_auth_token";
export const REQUESTING_USER_SESSION_TOKEN_STORAGE_KEY =
  "requesting_user_auth_token";

export function pushSessionToken(
  token: string,
  options?: { toSessionStorage?: boolean }
) {
  deleteSessionToken();

  if (options?.toSessionStorage) {
    window.sessionStorage.setItem(SESSION_TOKEN_STORAGE_KEY, token);
  } else {
    window.localStorage.setItem(SESSION_TOKEN_STORAGE_KEY, token);
  }
}

export function pullSessionToken() {
  return (
    window.sessionStorage.getItem(SESSION_TOKEN_STORAGE_KEY) ||
    window.localStorage.getItem(SESSION_TOKEN_STORAGE_KEY)
  );
}

export function deleteSessionToken() {
  window.sessionStorage.removeItem(SESSION_TOKEN_STORAGE_KEY);
  window.localStorage.removeItem(SESSION_TOKEN_STORAGE_KEY);
}

export function setAdminSessionToken(token: string) {
  window.sessionStorage.setItem(ADMIN_SESSION_TOKEN_STORAGE_KEY, token);
}

export function getAdminSessionToken() {
  return window.sessionStorage.getItem(ADMIN_SESSION_TOKEN_STORAGE_KEY);
}

export function deleteAdminSessionToken() {
  window.sessionStorage.removeItem(ADMIN_SESSION_TOKEN_STORAGE_KEY);
}

export function setRequestingUserSessionToken(token: string) {
  window.sessionStorage.setItem(
    REQUESTING_USER_SESSION_TOKEN_STORAGE_KEY,
    token
  );
}

export function getRequestingUserSessionToken() {
  return window.sessionStorage.getItem(
    REQUESTING_USER_SESSION_TOKEN_STORAGE_KEY
  );
}

export function deleteRequestingUserSessionToken() {
  window.sessionStorage.removeItem(REQUESTING_USER_SESSION_TOKEN_STORAGE_KEY);
}
